import {
  CREATE,
  DELETE,
  GET_LIST,
  GET_ONE,
  UPDATE,
} from 'react-admin'
import {convertImagePath} from './ImageHandler'

export function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/c2c/orders'
  let options = {}

  switch (type) {
    case GET_LIST:
      const {page, perPage} = params.pagination
      const {field, order} = params.sort
      options.params = {
        ...params.filter,
        sort: field,
        order: order,
        start: (page - 1) * perPage,
        perPage: perPage,
      }
      break
    case CREATE:
      options.method = 'POST'
      options.data = params.data
      break
    case GET_ONE:
      url += `/${params.id}`
      break
    case UPDATE:
      url += `/${params.id}`
      options.method = 'PUT'
      options.data = params.data
      break
    case 'UPDATE_DELIVERY':
      url += `/${params.id}/delivery`
      options.method = 'PUT'
      options.data = params.data
      break
    case 'UPDATE_STATUS':
      url += `/${params.id}/status`
      options.method = 'PUT'
      options.data = params.data
      break
    case 'UPDATE_MEMO':
      url += `/${params.id}/memo`
      options.method = 'PUT'
      options.data = params.data
      break
    case 'UPDATE_ADDRESS':
      url += `/${params.id}/address`
      options.method = 'PUT'
      options.data = params.data
      break
    case DELETE:
      console.log(params)
      url += `/${params.id}`
      options.method = 'DELETE'
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res
  switch (type) {
    case GET_LIST:
      data.list.forEach((item) => {
        item.mainImage = convertImagePath(item.mainImage, 'small')
      })
      ret = {data: data.list, total: data.total}
      break
    case GET_ONE:
      data.userSell.mainImage = convertImagePath(data.userSell.mainImage, 'small')
      data.inspectionPrice = `${data.inspectionPrice.toLocaleString()}(${data.inspectionRate}%)`
      ret = {data}
      break
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
